
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
} from "@mui/material";

import CurrencyCell from "../../../component/CurrencyCell";

const columns = [
  { field: "WORKORDERNUMBER", label: "Work Order", align: "left" },
  { field: "HIGHLYSKILLEDTIME", label: "H Skill Time", align: "right" },
  { field: "HIGHLYSKILLEDCOST", label: "PH Skill Cost", align: "right" },
   { field: "SKILLEDTIME", label: "Skilled Time", align: "right" },
  { field: "SKILLEDCOST", label: "Skilled Cost", align: "right" },
  { field: "SEMISKILLEDTIME", label: "S Skilled Time", align: "right" },
  { field: "SEMISKILLEDCOST", label: "S Skilled Cost", align: "right" },
  { field: "UNSKILLEDTIME", label: "UnSkilled Time", align: "right" },
  { field: "UNSKILLEDCOST", label: "UnSkilled Cost", align: "right" },
  { field: "ONCOSTLABOUR", label: "O/C Labour", align: "right" },
  { field: "ONCOSTSTORE", label: "O/C Store", align: "right" },
];

export default function WGRTable({ rows }) {
  return (
    <TableContainer>
      <Table
        size="small"
        stickyHeader
      >
        <TableHead>
          <TableRow>
            {columns.map((column) => (
              <TableCell
                key={column.field}
                align={column.align}
                sx={{
                  fontWeight: 700,
                  bgcolor: "grey.200",
                  whiteSpace: "nowrap",
                }}
              >
                {column.label}
              </TableCell>
            ))}
          </TableRow>
        </TableHead>

        <TableBody>
          {rows.map((row, index) => (
            <TableRow
              key={index}
              hover
              sx={{
                "&:nth-of-type(even)": {
                  bgcolor: "grey.50",
                },
              }}
            >



              
              <TableCell>
                {row.WORKORDERNUMBER}
              </TableCell>

              <TableCell align="right">
                <CurrencyCell
                  value={row.HIGHLYSKILLEDTIME}
                />
              </TableCell>

              <TableCell align="right">
                <CurrencyCell
                  value={row.HIGHLYSKILLEDCOST}
                />
              </TableCell>

            <TableCell align="right">
                <CurrencyCell
                  value={row.SKILLEDTIME}
                />
              </TableCell>

              <TableCell align="right">
                <CurrencyCell
                  value={row.SKILLEDCOST}
                />
              </TableCell>

              <TableCell align="right">
                <CurrencyCell
                  value={row.SEMISKILLEDTIME}
                />
              </TableCell>

              <TableCell align="right">
                <CurrencyCell
                  value={row.SEMISKILLEDCOST}
                />
              </TableCell>

              <TableCell align="right">
                <CurrencyCell
                  value={row.UNSKILLEDTIME}
                />
              </TableCell>

              <TableCell align="right">
                <CurrencyCell
                  value={row.UNSKILLEDCOST}
                />
              </TableCell>

              <TableCell align="right">
                <CurrencyCell
                  value={row.ONCOSTLABOUR}
                />
              </TableCell>

              <TableCell align="right">
                <CurrencyCell
                  value={row.ONCOSTSTORE}
                />
              </TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  );
}

